// This global state to allow organizer to overcome the attendee token
// we use this state because API calls can be execute at any context
// this state should be used ONLY for client() method in the index.js
let isOrganizerToken = false;

export const getIsOrganizerToken = () => {
    return isOrganizerToken;
};

// This setter can be called from outside => to allow organizer to overcome attendee token
// web partner for example will use it to make client method use the default token
export const setOrganizerToken = () => (isOrganizerToken = true);
